<template>
  <header class="diy-topbar">
    <TheTopbarLogo />
    <!-- MENU -->
    <TheTopbarNavbar />
  </header>
</template>

<script>
// Components
import TheTopbarLogo from './components/TheTopbarLogo'
import TheTopbarNavbar from './components/TheTopbarNavbar'

export default {
  name: 'TheTopbar',

  components: {
    TheTopbarLogo,
    TheTopbarNavbar,
  },
}
</script>

<style scoped>
.diy-topbar {
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: 0;
  left: 0;
  gap: 10px;
  width: 100%;
  height: var(--nav-size);
  background-color: var(--nav-bg);
  padding: 0 1rem;
  z-index: 10;
}

.diy-topbar__nav {
  display: flex;
  justify-content: flex-end;
  height: 100%;
  max-width: 100%;
}
</style>
